"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixProperties1ToJSON = exports.MixProperties1FromJSONTyped = exports.MixProperties1FromJSON = exports.instanceOfMixProperties1 = void 0;
var runtime_1 = require("../runtime");
var BackgroundMusic1_1 = require("./BackgroundMusic1");
/**
 * Check if a given object implements the MixProperties1 interface.
 */
function instanceOfMixProperties1(value) {
    var isInstance = true;
    isInstance = isInstance && "backgroundMusic" in value;
    return isInstance;
}
exports.instanceOfMixProperties1 = instanceOfMixProperties1;
function MixProperties1FromJSON(json) {
    return MixProperties1FromJSONTyped(json, false);
}
exports.MixProperties1FromJSON = MixProperties1FromJSON;
function MixProperties1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'backgroundMusic': (0, BackgroundMusic1_1.BackgroundMusic1FromJSON)(json['background_music']),
        'voiceStart': !(0, runtime_1.exists)(json, 'voice_start') ? undefined : json['voice_start'],
        'musicStart': !(0, runtime_1.exists)(json, 'music_start') ? undefined : json['music_start'],
        'musicVolume': !(0, runtime_1.exists)(json, 'music_volume') ? undefined : json['music_volume'],
        'duration': !(0, runtime_1.exists)(json, 'duration') ? undefined : json['duration'],
        'playFullMusic': !(0, runtime_1.exists)(json, 'play_full_music') ? undefined : json['play_full_music'],
    };
}
exports.MixProperties1FromJSONTyped = MixProperties1FromJSONTyped;
function MixProperties1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'background_music': (0, BackgroundMusic1_1.BackgroundMusic1ToJSON)(value.backgroundMusic),
        'voice_start': value.voiceStart,
        'music_start': value.musicStart,
        'music_volume': value.musicVolume,
        'duration': value.duration,
        'play_full_music': value.playFullMusic,
    };
}
exports.MixProperties1ToJSON = MixProperties1ToJSON;
